export default "__VITE_ASSET__DIf93VRh__"